//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const DVS_ADMIN_API_BASE_URL = new InjectionToken<string>('DVS_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminUserDocumentsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(DVS_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(documentType: DocumentType | null, status: UserDocumentStatus | null, userId: string | null, isDeleted: boolean | null, aiVerdict: UserFileAiVerdict | null, submitted: boolean | null, awaitingModerator: boolean | null, sortBy: AdminUserDocumentSortBy | null, sortDirection: SortDirection | null, page?: number | undefined, pageSize?: number | undefined): Observable<SwaggerResponse<AdminUserDocumentDto[]>> {
        let url_ = this.baseUrl + "/admin/user-documents?";
        if (documentType === undefined)
            throw new globalThis.Error("The parameter 'documentType' must be defined.");
        else if(documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (status === undefined)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        else if(status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (userId === undefined)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isDeleted === undefined)
            throw new globalThis.Error("The parameter 'isDeleted' must be defined.");
        else if(isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (aiVerdict === undefined)
            throw new globalThis.Error("The parameter 'aiVerdict' must be defined.");
        else if(aiVerdict !== null)
            url_ += "aiVerdict=" + encodeURIComponent("" + aiVerdict) + "&";
        if (submitted === undefined)
            throw new globalThis.Error("The parameter 'submitted' must be defined.");
        else if(submitted !== null)
            url_ += "submitted=" + encodeURIComponent("" + submitted) + "&";
        if (awaitingModerator === undefined)
            throw new globalThis.Error("The parameter 'awaitingModerator' must be defined.");
        else if(awaitingModerator !== null)
            url_ += "awaitingModerator=" + encodeURIComponent("" + awaitingModerator) + "&";
        if (sortBy === undefined)
            throw new globalThis.Error("The parameter 'sortBy' must be defined.");
        else if(sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === undefined)
            throw new globalThis.Error("The parameter 'sortDirection' must be defined.");
        else if(sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AdminUserDocumentDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AdminUserDocumentDto[]>>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SwaggerResponse<AdminUserDocumentDto[]>> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.Search');
            }));
        }
        return _observableOf<SwaggerResponse<AdminUserDocumentDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    get(documentId: number): Observable<AdminUserDocumentDetailDto> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentDetailDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdminUserDocumentDetailDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.Get');
            }));
        }
        return _observableOf(null as any);
    }

    delete(documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.Delete');
            }));
        }
        return _observableOf(null as any);
    }

    getPageContent(documentId: number, pageId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/pages/{pageId}/content";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (pageId === undefined || pageId === null)
            throw new globalThis.Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPageContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBody as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.GetPageContent');
            }));
        }
        return _observableOf(null as any);
    }

    decide(documentId: number, request: AdminUserDocumentDecisionRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/decision";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDecide(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.Decide');
            }));
        }
        return _observableOf(null as any);
    }

    approveWithDocument(documentId: number, request: AdminUserDocumentApproveWithDocumentRequestDto): Observable<AdminUserDocumentVerifiedDocumentDto> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/approve-with-document";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveWithDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveWithDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentVerifiedDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentVerifiedDocumentDto>;
        }));
    }

    protected processApproveWithDocument(response: HttpResponseBase): Observable<AdminUserDocumentVerifiedDocumentDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentVerifiedDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.ApproveWithDocument');
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(documentId: number): Observable<AdminUserDocumentHistoryEntryDto[]> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/history";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentHistoryEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentHistoryEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<AdminUserDocumentHistoryEntryDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserDocumentHistoryEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.GetHistory');
            }));
        }
        return _observableOf(null as any);
    }

    recordProfileUpdatedFromDocument(documentId: number, request: AdminUserDocumentProfileUpdatedFromDocumentRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/profile-updated-from-document";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordProfileUpdatedFromDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordProfileUpdatedFromDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecordProfileUpdatedFromDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.RecordProfileUpdatedFromDocument');
            }));
        }
        return _observableOf(null as any);
    }

    getDocument(documentId: number): Observable<AdminUserDocumentVerifiedDocumentDto> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/document";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentVerifiedDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentVerifiedDocumentDto>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<AdminUserDocumentVerifiedDocumentDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentVerifiedDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.GetDocument');
            }));
        }
        return _observableOf(null as any);
    }

    listAiChecks(userId: string): Observable<AdminUserDocumentAiChecksDto> {
        let url_ = this.baseUrl + "/admin/user-documents/ai-checks?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListAiChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAiChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentAiChecksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentAiChecksDto>;
        }));
    }

    protected processListAiChecks(response: HttpResponseBase): Observable<AdminUserDocumentAiChecksDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentAiChecksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.ListAiChecks');
            }));
        }
        return _observableOf(null as any);
    }

    getAiCheckReport(startDate: Date, endDate: Date, timeOffsetInMinutes: number): Observable<AdminUserDocumentAiCheckReportDto> {
        let url_ = this.baseUrl + "/admin/user-documents/ai-checks/report?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (timeOffsetInMinutes === undefined || timeOffsetInMinutes === null)
            throw new globalThis.Error("The parameter 'timeOffsetInMinutes' must be defined and cannot be null.");
        else
            url_ += "timeOffsetInMinutes=" + encodeURIComponent("" + timeOffsetInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiCheckReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiCheckReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentAiCheckReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentAiCheckReportDto>;
        }));
    }

    protected processGetAiCheckReport(response: HttpResponseBase): Observable<AdminUserDocumentAiCheckReportDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentAiCheckReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.GetAiCheckReport');
            }));
        }
        return _observableOf(null as any);
    }

    getAiCheck(documentId: number): Observable<AdminUserDocumentAiCheckDto> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/ai-check";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentAiCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentAiCheckDto>;
        }));
    }

    protected processGetAiCheck(response: HttpResponseBase): Observable<AdminUserDocumentAiCheckDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentAiCheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.GetAiCheck');
            }));
        }
        return _observableOf(null as any);
    }

    requestAiCheck(documentId: number): Observable<AdminUserDocumentAiCheckDto> {
        let url_ = this.baseUrl + "/admin/user-documents/{documentId}/ai-check";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAiCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAiCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentAiCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentAiCheckDto>;
        }));
    }

    protected processRequestAiCheck(response: HttpResponseBase): Observable<AdminUserDocumentAiCheckDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = AdminUserDocumentAiCheckDto.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.RequestAiCheck');
            }));
        }
        return _observableOf(null as any);
    }

    rerunAiChecks(request: AdminUserDocumentAiCheckBulkRequestDto): Observable<AdminUserDocumentAiCheckBulkResultDto> {
        let url_ = this.baseUrl + "/admin/user-documents/ai-checks/re-run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRerunAiChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRerunAiChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDocumentAiCheckBulkResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDocumentAiCheckBulkResultDto>;
        }));
    }

    protected processRerunAiChecks(response: HttpResponseBase): Observable<AdminUserDocumentAiCheckBulkResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUserDocumentAiCheckBulkResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUserDocumentsClient.RerunAiChecks');
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminDocumentsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(DVS_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(stateType: DocumentStateType | null, isDeleted: boolean | null, userId: string | null, documentKey: string | null, page?: number | undefined, pageSize?: number | undefined): Observable<SwaggerResponse<AdminDocumentDto[]>> {
        let url_ = this.baseUrl + "/admin/documents?";
        if (stateType === undefined)
            throw new globalThis.Error("The parameter 'stateType' must be defined.");
        else if(stateType !== null)
            url_ += "stateType=" + encodeURIComponent("" + stateType) + "&";
        if (isDeleted === undefined)
            throw new globalThis.Error("The parameter 'isDeleted' must be defined.");
        else if(isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (userId === undefined)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (documentKey === undefined)
            throw new globalThis.Error("The parameter 'documentKey' must be defined.");
        else if(documentKey !== null)
            url_ += "documentKey=" + encodeURIComponent("" + documentKey) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AdminDocumentDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AdminDocumentDto[]>>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SwaggerResponse<AdminDocumentDto[]>> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.Search');
            }));
        }
        return _observableOf<SwaggerResponse<AdminDocumentDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    create(request: AdminDocumentCreateRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.Create');
            }));
        }
        return _observableOf(null as any);
    }

    getMetadata(): Observable<AdminDocumentMetadataDto[]> {
        let url_ = this.baseUrl + "/admin/documents/metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentMetadataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentMetadataDto[]>;
        }));
    }

    protected processGetMetadata(response: HttpResponseBase): Observable<AdminDocumentMetadataDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDocumentMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.GetMetadata');
            }));
        }
        return _observableOf(null as any);
    }

    getDetail(documentId: number): Observable<AdminDocumentDetailDto> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentDetailDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<AdminDocumentDetailDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDocumentDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.GetDetail');
            }));
        }
        return _observableOf(null as any);
    }

    edit(documentId: number, request: AdminDocumentEditRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.Edit');
            }));
        }
        return _observableOf(null as any);
    }

    delete(documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.Delete');
            }));
        }
        return _observableOf(null as any);
    }

    getFileContent(documentId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/files/{fileId}/content";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFileContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBody as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.GetFileContent');
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(file?: FileParameter | null | undefined): Observable<AdminDocumentFileUploadResultDto> {
        let url_ = this.baseUrl + "/admin/documents/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentFileUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentFileUploadResultDto>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<AdminDocumentFileUploadResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDocumentFileUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.UploadFile');
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(documentId: number): Observable<AdminDocumentHistoryEntryDto[]> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/history";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentHistoryEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentHistoryEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<AdminDocumentHistoryEntryDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDocumentHistoryEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.GetHistory');
            }));
        }
        return _observableOf(null as any);
    }

    applyVerificationAction(documentId: number, request: AdminDocumentVerificationRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/verification";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyVerificationAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyVerificationAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyVerificationAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.ApplyVerificationAction');
            }));
        }
        return _observableOf(null as any);
    }

    checkPassport(documentId: number): Observable<AdminDocumentPassportCheckResultDto> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/passport-check";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPassport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPassport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentPassportCheckResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentPassportCheckResultDto>;
        }));
    }

    protected processCheckPassport(response: HttpResponseBase): Observable<AdminDocumentPassportCheckResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDocumentPassportCheckResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.CheckPassport');
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminUserDocumentDto implements IAdminUserDocumentDto {
    documentId!: number;
    documentType!: DocumentType;
    status!: UserDocumentStatus;
    createdAt!: Date;
    submittedAt!: Date | undefined;
    waitingSince!: Date | undefined;
    decidedAt!: Date | undefined;
    deletedAt!: Date | undefined;
    pagesCount!: number;
    pagesVersion!: number;
    firstPageFileName!: string | undefined;
    userId!: string;
    customerHumanReadableId!: number | undefined;
    customerName!: string | undefined;
    customerRoleType!: AdminCustomerRole | undefined;
    aiCheckStatus!: UserFileAiCheckStatus | undefined;
    aiVerdict!: UserFileAiVerdict | undefined;
    aiRiskFlags!: UserFileAiRiskFlags[] | undefined;

    constructor(data?: IAdminUserDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.waitingSince = _data["waitingSince"] ? new Date(_data["waitingSince"].toString()) : undefined as any;
            this.decidedAt = _data["decidedAt"] ? new Date(_data["decidedAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
            this.pagesCount = _data["pagesCount"];
            this.pagesVersion = _data["pagesVersion"];
            this.firstPageFileName = _data["firstPageFileName"];
            this.userId = _data["userId"];
            this.customerHumanReadableId = _data["customerHumanReadableId"];
            this.customerName = _data["customerName"];
            this.customerRoleType = _data["customerRoleType"];
            this.aiCheckStatus = _data["aiCheckStatus"];
            this.aiVerdict = _data["aiVerdict"];
            if (Array.isArray(_data["aiRiskFlags"])) {
                this.aiRiskFlags = [] as any;
                for (let item of _data["aiRiskFlags"])
                    this.aiRiskFlags!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["waitingSince"] = this.waitingSince ? this.waitingSince.toISOString() : undefined as any;
        data["decidedAt"] = this.decidedAt ? this.decidedAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        data["pagesCount"] = this.pagesCount;
        data["pagesVersion"] = this.pagesVersion;
        data["firstPageFileName"] = this.firstPageFileName;
        data["userId"] = this.userId;
        data["customerHumanReadableId"] = this.customerHumanReadableId;
        data["customerName"] = this.customerName;
        data["customerRoleType"] = this.customerRoleType;
        data["aiCheckStatus"] = this.aiCheckStatus;
        data["aiVerdict"] = this.aiVerdict;
        if (Array.isArray(this.aiRiskFlags)) {
            data["aiRiskFlags"] = [];
            for (let item of this.aiRiskFlags)
                data["aiRiskFlags"].push(item);
        }
        return data;
    }
}

export interface IAdminUserDocumentDto {
    documentId: number;
    documentType: DocumentType;
    status: UserDocumentStatus;
    createdAt: Date;
    submittedAt: Date | undefined;
    waitingSince: Date | undefined;
    decidedAt: Date | undefined;
    deletedAt: Date | undefined;
    pagesCount: number;
    pagesVersion: number;
    firstPageFileName: string | undefined;
    userId: string;
    customerHumanReadableId: number | undefined;
    customerName: string | undefined;
    customerRoleType: AdminCustomerRole | undefined;
    aiCheckStatus: UserFileAiCheckStatus | undefined;
    aiVerdict: UserFileAiVerdict | undefined;
    aiRiskFlags: UserFileAiRiskFlags[] | undefined;
}

export enum DocumentType {
    Undefined = "Undefined",
    Passport = "Passport",
    MedicalBook = "MedicalBook",
    PoliceCheck = "PoliceCheck",
    Other = "Other",
    DriverLicense = "DriverLicense",
    CprCert = "CprCert",
    FirstAidCert = "FirstAidCert",
}

export enum UserDocumentStatus {
    InProcess = "InProcess",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum AdminCustomerRole {
    Undefined = 0,
    Worker = 1,
    Employer = 2,
}

export enum UserFileAiCheckStatus {
    Undefined = "Undefined",
    Queued = "Queued",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
    Superseded = "Superseded",
}

export enum UserFileAiVerdict {
    Undefined = "Undefined",
    Match = "Match",
    Discrepancies = "Discrepancies",
    Unrecognized = "Unrecognized",
}

export enum UserFileAiRiskFlags {
    None = "None",
    Expired = "Expired",
    ExpiringSoon = "ExpiringSoon",
    PoorImageQuality = "PoorImageQuality",
    PossibleTampering = "PossibleTampering",
    WrongDocumentType = "WrongDocumentType",
    NotADocument = "NotADocument",
    UnderAge = "UnderAge",
    DueForRenewal = "DueForRenewal",
    StaleCheck = "StaleCheck",
    AdverseResult = "AdverseResult",
    MrzMismatch = "MrzMismatch",
    OutcomeNotClear = "OutcomeNotClear",
}

export enum AdminUserDocumentSortBy {
    Undefined = "Undefined",
    DocumentId = "DocumentId",
    DocumentType = "DocumentType",
    Status = "Status",
    PagesCount = "PagesCount",
    CreatedAt = "CreatedAt",
    SubmittedAt = "SubmittedAt",
    DecidedAt = "DecidedAt",
    DeletedAt = "DeletedAt",
}

export enum SortDirection {
    Undefined = "Undefined",
    Asc = "Asc",
    Desc = "Desc",
}

export class AdminUserDocumentDetailDto implements IAdminUserDocumentDetailDto {
    document!: AdminUserDocumentDto | undefined;
    pages!: AdminUserDocumentPageDto[] | undefined;
    latestAiCheck!: AdminUserDocumentAiCheckDto | undefined;

    constructor(data?: IAdminUserDocumentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? AdminUserDocumentDto.fromJS(_data["document"]) : undefined as any;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(AdminUserDocumentPageDto.fromJS(item));
            }
            this.latestAiCheck = _data["latestAiCheck"] ? AdminUserDocumentAiCheckDto.fromJS(_data["latestAiCheck"]) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["latestAiCheck"] = this.latestAiCheck ? this.latestAiCheck.toJSON() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentDetailDto {
    document: AdminUserDocumentDto | undefined;
    pages: AdminUserDocumentPageDto[] | undefined;
    latestAiCheck: AdminUserDocumentAiCheckDto | undefined;
}

export class AdminUserDocumentPageDto implements IAdminUserDocumentPageDto {
    pageId!: number;
    physicalFileId!: string;
    fileName!: string | undefined;
    position!: number;
    createdAt!: Date;
    deletedAt!: Date | undefined;

    constructor(data?: IAdminUserDocumentPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            this.physicalFileId = _data["physicalFileId"];
            this.fileName = _data["fileName"];
            this.position = _data["position"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        data["physicalFileId"] = this.physicalFileId;
        data["fileName"] = this.fileName;
        data["position"] = this.position;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentPageDto {
    pageId: number;
    physicalFileId: string;
    fileName: string | undefined;
    position: number;
    createdAt: Date;
    deletedAt: Date | undefined;
}

export class AdminUserDocumentAiCheckDto implements IAdminUserDocumentAiCheckDto {
    documentId!: number;
    pages!: AdminUserDocumentAiPageDto[] | undefined;
    checkId!: number;
    status!: UserFileAiCheckStatus;
    verdict!: UserFileAiVerdict | undefined;
    confidence!: UserFileAiConfidence | undefined;
    riskFlags!: UserFileAiRiskFlags[] | undefined;
    detectedDocumentType!: DocumentType | undefined;
    documentKind!: string | undefined;
    documentClass!: UserFileDocumentClass | undefined;
    satisfies!: UserFileRequirement[] | undefined;
    uploadedRequirement!: UserFileRequirement | undefined;
    comparison!: AdminUserDocumentAiComparisonRowDto[] | undefined;
    nameSpellings!: AdminUserDocumentAiNameSpellingDto[] | undefined;
    mrz!: AdminUserDocumentAiMrzDto | undefined;
    judgement!: AdminUserDocumentAiJudgementDto | undefined;
    autoDocumentOutcome!: UserFileAiAutoDocumentOutcome | undefined;
    autoDocumentAction!: UserFileAutoDocumentOutcome | undefined;
    autoDocumentActionDetails!: string | undefined;
    autoDocumentBlockers!: UserFileAutoDocumentApprovalBlocker[] | undefined;
    identityConfirmation!: AdminUserDocumentAiIdentityConfirmationDto | undefined;
    customerGuidance!: AdminUserDocumentAiCustomerGuidanceDto | undefined;
    autoReject!: AdminUserDocumentAiAutoRejectDto | undefined;
    profileCorrection!: AdminUserDocumentAiProfileCorrectionDto | undefined;
    notes!: string | undefined;
    tamperingNotes!: string | undefined;
    model!: string | undefined;
    stageTokens!: AdminUserDocumentAiStageTokensDto[] | undefined;
    promptVersion!: string | undefined;
    profileChangedSinceCheck!: boolean | undefined;
    error!: string | undefined;
    createdAt!: Date;
    completedAt!: Date | undefined;
    requestedByName!: string | undefined;
    applyAutoReject!: boolean;

    constructor(data?: IAdminUserDocumentAiCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(AdminUserDocumentAiPageDto.fromJS(item));
            }
            this.checkId = _data["checkId"];
            this.status = _data["status"];
            this.verdict = _data["verdict"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["riskFlags"])) {
                this.riskFlags = [] as any;
                for (let item of _data["riskFlags"])
                    this.riskFlags!.push(item);
            }
            this.detectedDocumentType = _data["detectedDocumentType"];
            this.documentKind = _data["documentKind"];
            this.documentClass = _data["documentClass"];
            if (Array.isArray(_data["satisfies"])) {
                this.satisfies = [] as any;
                for (let item of _data["satisfies"])
                    this.satisfies!.push(item);
            }
            this.uploadedRequirement = _data["uploadedRequirement"];
            if (Array.isArray(_data["comparison"])) {
                this.comparison = [] as any;
                for (let item of _data["comparison"])
                    this.comparison!.push(AdminUserDocumentAiComparisonRowDto.fromJS(item));
            }
            if (Array.isArray(_data["nameSpellings"])) {
                this.nameSpellings = [] as any;
                for (let item of _data["nameSpellings"])
                    this.nameSpellings!.push(AdminUserDocumentAiNameSpellingDto.fromJS(item));
            }
            this.mrz = _data["mrz"] ? AdminUserDocumentAiMrzDto.fromJS(_data["mrz"]) : undefined as any;
            this.judgement = _data["judgement"] ? AdminUserDocumentAiJudgementDto.fromJS(_data["judgement"]) : undefined as any;
            this.autoDocumentOutcome = _data["autoDocumentOutcome"];
            this.autoDocumentAction = _data["autoDocumentAction"];
            this.autoDocumentActionDetails = _data["autoDocumentActionDetails"];
            if (Array.isArray(_data["autoDocumentBlockers"])) {
                this.autoDocumentBlockers = [] as any;
                for (let item of _data["autoDocumentBlockers"])
                    this.autoDocumentBlockers!.push(item);
            }
            this.identityConfirmation = _data["identityConfirmation"] ? AdminUserDocumentAiIdentityConfirmationDto.fromJS(_data["identityConfirmation"]) : undefined as any;
            this.customerGuidance = _data["customerGuidance"] ? AdminUserDocumentAiCustomerGuidanceDto.fromJS(_data["customerGuidance"]) : undefined as any;
            this.autoReject = _data["autoReject"] ? AdminUserDocumentAiAutoRejectDto.fromJS(_data["autoReject"]) : undefined as any;
            this.profileCorrection = _data["profileCorrection"] ? AdminUserDocumentAiProfileCorrectionDto.fromJS(_data["profileCorrection"]) : undefined as any;
            this.notes = _data["notes"];
            this.tamperingNotes = _data["tamperingNotes"];
            this.model = _data["model"];
            if (Array.isArray(_data["stageTokens"])) {
                this.stageTokens = [] as any;
                for (let item of _data["stageTokens"])
                    this.stageTokens!.push(AdminUserDocumentAiStageTokensDto.fromJS(item));
            }
            this.promptVersion = _data["promptVersion"];
            this.profileChangedSinceCheck = _data["profileChangedSinceCheck"];
            this.error = _data["error"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.requestedByName = _data["requestedByName"];
            this.applyAutoReject = _data["applyAutoReject"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["checkId"] = this.checkId;
        data["status"] = this.status;
        data["verdict"] = this.verdict;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.riskFlags)) {
            data["riskFlags"] = [];
            for (let item of this.riskFlags)
                data["riskFlags"].push(item);
        }
        data["detectedDocumentType"] = this.detectedDocumentType;
        data["documentKind"] = this.documentKind;
        data["documentClass"] = this.documentClass;
        if (Array.isArray(this.satisfies)) {
            data["satisfies"] = [];
            for (let item of this.satisfies)
                data["satisfies"].push(item);
        }
        data["uploadedRequirement"] = this.uploadedRequirement;
        if (Array.isArray(this.comparison)) {
            data["comparison"] = [];
            for (let item of this.comparison)
                data["comparison"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nameSpellings)) {
            data["nameSpellings"] = [];
            for (let item of this.nameSpellings)
                data["nameSpellings"].push(item ? item.toJSON() : undefined as any);
        }
        data["mrz"] = this.mrz ? this.mrz.toJSON() : undefined as any;
        data["judgement"] = this.judgement ? this.judgement.toJSON() : undefined as any;
        data["autoDocumentOutcome"] = this.autoDocumentOutcome;
        data["autoDocumentAction"] = this.autoDocumentAction;
        data["autoDocumentActionDetails"] = this.autoDocumentActionDetails;
        if (Array.isArray(this.autoDocumentBlockers)) {
            data["autoDocumentBlockers"] = [];
            for (let item of this.autoDocumentBlockers)
                data["autoDocumentBlockers"].push(item);
        }
        data["identityConfirmation"] = this.identityConfirmation ? this.identityConfirmation.toJSON() : undefined as any;
        data["customerGuidance"] = this.customerGuidance ? this.customerGuidance.toJSON() : undefined as any;
        data["autoReject"] = this.autoReject ? this.autoReject.toJSON() : undefined as any;
        data["profileCorrection"] = this.profileCorrection ? this.profileCorrection.toJSON() : undefined as any;
        data["notes"] = this.notes;
        data["tamperingNotes"] = this.tamperingNotes;
        data["model"] = this.model;
        if (Array.isArray(this.stageTokens)) {
            data["stageTokens"] = [];
            for (let item of this.stageTokens)
                data["stageTokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["promptVersion"] = this.promptVersion;
        data["profileChangedSinceCheck"] = this.profileChangedSinceCheck;
        data["error"] = this.error;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["requestedByName"] = this.requestedByName;
        data["applyAutoReject"] = this.applyAutoReject;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckDto {
    documentId: number;
    pages: AdminUserDocumentAiPageDto[] | undefined;
    checkId: number;
    status: UserFileAiCheckStatus;
    verdict: UserFileAiVerdict | undefined;
    confidence: UserFileAiConfidence | undefined;
    riskFlags: UserFileAiRiskFlags[] | undefined;
    detectedDocumentType: DocumentType | undefined;
    documentKind: string | undefined;
    documentClass: UserFileDocumentClass | undefined;
    satisfies: UserFileRequirement[] | undefined;
    uploadedRequirement: UserFileRequirement | undefined;
    comparison: AdminUserDocumentAiComparisonRowDto[] | undefined;
    nameSpellings: AdminUserDocumentAiNameSpellingDto[] | undefined;
    mrz: AdminUserDocumentAiMrzDto | undefined;
    judgement: AdminUserDocumentAiJudgementDto | undefined;
    autoDocumentOutcome: UserFileAiAutoDocumentOutcome | undefined;
    autoDocumentAction: UserFileAutoDocumentOutcome | undefined;
    autoDocumentActionDetails: string | undefined;
    autoDocumentBlockers: UserFileAutoDocumentApprovalBlocker[] | undefined;
    identityConfirmation: AdminUserDocumentAiIdentityConfirmationDto | undefined;
    customerGuidance: AdminUserDocumentAiCustomerGuidanceDto | undefined;
    autoReject: AdminUserDocumentAiAutoRejectDto | undefined;
    profileCorrection: AdminUserDocumentAiProfileCorrectionDto | undefined;
    notes: string | undefined;
    tamperingNotes: string | undefined;
    model: string | undefined;
    stageTokens: AdminUserDocumentAiStageTokensDto[] | undefined;
    promptVersion: string | undefined;
    profileChangedSinceCheck: boolean | undefined;
    error: string | undefined;
    createdAt: Date;
    completedAt: Date | undefined;
    requestedByName: string | undefined;
    applyAutoReject: boolean;
}

export class AdminUserDocumentAiPageDto implements IAdminUserDocumentAiPageDto {
    page!: number;
    pageId!: number;
    pageIndex!: number;
    role!: UserFileAiPageRole | undefined;

    constructor(data?: IAdminUserDocumentAiPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageId = _data["pageId"];
            this.pageIndex = _data["pageIndex"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageId"] = this.pageId;
        data["pageIndex"] = this.pageIndex;
        data["role"] = this.role;
        return data;
    }
}

export interface IAdminUserDocumentAiPageDto {
    page: number;
    pageId: number;
    pageIndex: number;
    role: UserFileAiPageRole | undefined;
}

export enum UserFileAiPageRole {
    Undefined = "Undefined",
    Holder = "Holder",
    Result = "Result",
    Supplementary = "Supplementary",
    Other = "Other",
}

export enum UserFileAiConfidence {
    Undefined = "Undefined",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum UserFileDocumentClass {
    Undefined = "Undefined",
    Passport = "Passport",
    IdCard = "IdCard",
    ResidencePermit = "ResidencePermit",
    DriverLicense = "DriverLicense",
    PoliceCheck = "PoliceCheck",
    MedicalBook = "MedicalBook",
    TrainingCertificate = "TrainingCertificate",
    Other = "Other",
    Unknown = "Unknown",
}

export enum UserFileRequirement {
    None = "None",
    Identity = "Identity",
    DriverLicense = "DriverLicense",
    CriminalCheck = "CriminalCheck",
    Medical = "Medical",
    FirstAid = "FirstAid",
    Cpr = "Cpr",
}

export class AdminUserDocumentAiComparisonRowDto implements IAdminUserDocumentAiComparisonRowDto {
    field!: UserFileAiComparedField;
    documentValue!: string | undefined;
    profileValue!: string | undefined;
    status!: UserFileAiFieldStatus;
    confidence!: number | undefined;
    note!: string | undefined;
    reason!: string | undefined;
    reasonCode!: JudgedFieldReasonCode | undefined;
    matchedSpelling!: string | undefined;

    constructor(data?: IAdminUserDocumentAiComparisonRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.documentValue = _data["documentValue"];
            this.profileValue = _data["profileValue"];
            this.status = _data["status"];
            this.confidence = _data["confidence"];
            this.note = _data["note"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
            this.matchedSpelling = _data["matchedSpelling"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiComparisonRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiComparisonRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["documentValue"] = this.documentValue;
        data["profileValue"] = this.profileValue;
        data["status"] = this.status;
        data["confidence"] = this.confidence;
        data["note"] = this.note;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        data["matchedSpelling"] = this.matchedSpelling;
        return data;
    }
}

export interface IAdminUserDocumentAiComparisonRowDto {
    field: UserFileAiComparedField;
    documentValue: string | undefined;
    profileValue: string | undefined;
    status: UserFileAiFieldStatus;
    confidence: number | undefined;
    note: string | undefined;
    reason: string | undefined;
    reasonCode: JudgedFieldReasonCode | undefined;
    matchedSpelling: string | undefined;
}

export enum UserFileAiComparedField {
    Undefined = "Undefined",
    LastName = "LastName",
    FirstName = "FirstName",
    MiddleName = "MiddleName",
    BirthDate = "BirthDate",
    DocumentNumber = "DocumentNumber",
    IssueDate = "IssueDate",
    ExpiryDate = "ExpiryDate",
}

export enum UserFileAiFieldStatus {
    Undefined = "Undefined",
    Match = "Match",
    Mismatch = "Mismatch",
    NotOnDocument = "NotOnDocument",
    Unreadable = "Unreadable",
    NotInProfile = "NotInProfile",
}

export enum JudgedFieldReasonCode {
    Undefined = "Undefined",
    Variant = "Variant",
    Transliteration = "Transliteration",
    Diminutive = "Diminutive",
    Reordered = "Reordered",
    Initial = "Initial",
    OneLetter = "OneLetter",
    SubsetOfGivenNames = "SubsetOfGivenNames",
    NotPrinted = "NotPrinted",
    Cropped = "Cropped",
    Different = "Different",
}

export class AdminUserDocumentAiNameSpellingDto implements IAdminUserDocumentAiNameSpellingDto {
    script!: UserFileAiNameScript;
    source!: UserFileAiNameSource;
    label!: string | undefined;
    lastName!: string | undefined;
    givenNames!: string | undefined;
    middleName!: string | undefined;
    fullAsPrinted!: string | undefined;
    confidence!: number;

    constructor(data?: IAdminUserDocumentAiNameSpellingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.script = _data["script"];
            this.source = _data["source"];
            this.label = _data["label"];
            this.lastName = _data["lastName"];
            this.givenNames = _data["givenNames"];
            this.middleName = _data["middleName"];
            this.fullAsPrinted = _data["fullAsPrinted"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiNameSpellingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiNameSpellingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["script"] = this.script;
        data["source"] = this.source;
        data["label"] = this.label;
        data["lastName"] = this.lastName;
        data["givenNames"] = this.givenNames;
        data["middleName"] = this.middleName;
        data["fullAsPrinted"] = this.fullAsPrinted;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IAdminUserDocumentAiNameSpellingDto {
    script: UserFileAiNameScript;
    source: UserFileAiNameSource;
    label: string | undefined;
    lastName: string | undefined;
    givenNames: string | undefined;
    middleName: string | undefined;
    fullAsPrinted: string | undefined;
    confidence: number;
}

export enum UserFileAiNameScript {
    Undefined = "Undefined",
    Latin = "Latin",
    Cyrillic = "Cyrillic",
    Hebrew = "Hebrew",
    Arabic = "Arabic",
    Other = "Other",
}

export enum UserFileAiNameSource {
    Undefined = "Undefined",
    Visual = "Visual",
    Mrz = "Mrz",
}

export class AdminUserDocumentAiMrzDto implements IAdminUserDocumentAiMrzDto {
    state!: UserFileAiMrzState;
    mismatchedFields!: UserFileAiComparedField[] | undefined;

    constructor(data?: IAdminUserDocumentAiMrzDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["mismatchedFields"])) {
                this.mismatchedFields = [] as any;
                for (let item of _data["mismatchedFields"])
                    this.mismatchedFields!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentAiMrzDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiMrzDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.mismatchedFields)) {
            data["mismatchedFields"] = [];
            for (let item of this.mismatchedFields)
                data["mismatchedFields"].push(item);
        }
        return data;
    }
}

export interface IAdminUserDocumentAiMrzDto {
    state: UserFileAiMrzState;
    mismatchedFields: UserFileAiComparedField[] | undefined;
}

export enum UserFileAiMrzState {
    Undefined = "Undefined",
    Verified = "Verified",
    Mismatch = "Mismatch",
    Ignored = "Ignored",
}

export class AdminUserDocumentAiJudgementDto implements IAdminUserDocumentAiJudgementDto {
    samePerson!: SamePersonVerdict;
    confidence!: number;
    reason!: string | undefined;
    reasonCode!: SamePersonReasonCode | undefined;

    constructor(data?: IAdminUserDocumentAiJudgementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.samePerson = _data["samePerson"];
            this.confidence = _data["confidence"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiJudgementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiJudgementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["samePerson"] = this.samePerson;
        data["confidence"] = this.confidence;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        return data;
    }
}

export interface IAdminUserDocumentAiJudgementDto {
    samePerson: SamePersonVerdict;
    confidence: number;
    reason: string | undefined;
    reasonCode: SamePersonReasonCode | undefined;
}

export enum SamePersonVerdict {
    Undefined = "Undefined",
    Same = "Same",
    Different = "Different",
    Unsure = "Unsure",
}

export enum SamePersonReasonCode {
    Undefined = "Undefined",
    SamePerson = "SamePerson",
    SurnameDiffers = "SurnameDiffers",
    GivenNameDiffers = "GivenNameDiffers",
    BirthDateDiffers = "BirthDateDiffers",
    ProfileIncomplete = "ProfileIncomplete",
    DocumentIncomplete = "DocumentIncomplete",
    Cropped = "Cropped",
    Other = "Other",
}

export enum UserFileAiAutoDocumentOutcome {
    Undefined = "Undefined",
    Created = "Created",
    Verified = "Verified",
}

export enum UserFileAutoDocumentOutcome {
    Undefined = "Undefined",
    Disabled = "Disabled",
    NotPositive = "NotPositive",
    NoDocumentType = "NoDocumentType",
    FileUnavailable = "FileUnavailable",
    FileRejected = "FileRejected",
    AlreadyCreated = "AlreadyCreated",
    ExistingDocument = "ExistingDocument",
    Created = "Created",
    Verified = "Verified",
    VerifyFailed = "VerifyFailed",
    CreatedNeedsModerator = "CreatedNeedsModerator",
    DocumentChanged = "DocumentChanged",
}

export enum UserFileAutoDocumentApprovalBlocker {
    Undefined = "Undefined",
    LastNameNotMatched = "LastNameNotMatched",
    FirstNameNotMatched = "FirstNameNotMatched",
    MiddleNameNotMatched = "MiddleNameNotMatched",
    BirthDateNotMatched = "BirthDateNotMatched",
    IssueDateNotRead = "IssueDateNotRead",
    ExpiryDateNotRead = "ExpiryDateNotRead",
    OutcomeNotClear = "OutcomeNotClear",
    DocumentTypeNotConfirmed = "DocumentTypeNotConfirmed",
    ExaminationNotCurrent = "ExaminationNotCurrent",
    NameApproximatelyMatched = "NameApproximatelyMatched",
    IdentityNotConfirmedByJudge = "IdentityNotConfirmedByJudge",
    JudgedFieldNotAsPrinted = "JudgedFieldNotAsPrinted",
    BirthDateCenturyUncertain = "BirthDateCenturyUncertain",
    IdentityNotIndependentlyConfirmed = "IdentityNotIndependentlyConfirmed",
    ProfileIncomplete = "ProfileIncomplete",
}

export class AdminUserDocumentAiIdentityConfirmationDto implements IAdminUserDocumentAiIdentityConfirmationDto {
    state!: UserFileAiIdentityConfirmation;
    agreed!: UserFileAiComparedField[] | undefined;
    disagreed!: UserFileAiComparedField[] | undefined;
    unknown!: UserFileAiComparedField[] | undefined;
    note!: string | undefined;

    constructor(data?: IAdminUserDocumentAiIdentityConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["agreed"])) {
                this.agreed = [] as any;
                for (let item of _data["agreed"])
                    this.agreed!.push(item);
            }
            if (Array.isArray(_data["disagreed"])) {
                this.disagreed = [] as any;
                for (let item of _data["disagreed"])
                    this.disagreed!.push(item);
            }
            if (Array.isArray(_data["unknown"])) {
                this.unknown = [] as any;
                for (let item of _data["unknown"])
                    this.unknown!.push(item);
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiIdentityConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiIdentityConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.agreed)) {
            data["agreed"] = [];
            for (let item of this.agreed)
                data["agreed"].push(item);
        }
        if (Array.isArray(this.disagreed)) {
            data["disagreed"] = [];
            for (let item of this.disagreed)
                data["disagreed"].push(item);
        }
        if (Array.isArray(this.unknown)) {
            data["unknown"] = [];
            for (let item of this.unknown)
                data["unknown"].push(item);
        }
        data["note"] = this.note;
        return data;
    }
}

export interface IAdminUserDocumentAiIdentityConfirmationDto {
    state: UserFileAiIdentityConfirmation;
    agreed: UserFileAiComparedField[] | undefined;
    disagreed: UserFileAiComparedField[] | undefined;
    unknown: UserFileAiComparedField[] | undefined;
    note: string | undefined;
}

export enum UserFileAiIdentityConfirmation {
    Undefined = "Undefined",
    Mrz = "Mrz",
    SecondReading = "SecondReading",
    NotConfirmed = "NotConfirmed",
}

export class AdminUserDocumentAiCustomerGuidanceDto implements IAdminUserDocumentAiCustomerGuidanceDto {
    reason!: UserFileAiGuidanceReason;
    message!: string | undefined;

    constructor(data?: IAdminUserDocumentAiCustomerGuidanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCustomerGuidanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCustomerGuidanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["message"] = this.message;
        return data;
    }
}

export interface IAdminUserDocumentAiCustomerGuidanceDto {
    reason: UserFileAiGuidanceReason;
    message: string | undefined;
}

export enum UserFileAiGuidanceReason {
    Undefined = "Undefined",
    WrongPage = "WrongPage",
    WrongDocument = "WrongDocument",
    NotADocument = "NotADocument",
    Unreadable = "Unreadable",
    Cropped = "Cropped",
    HolderPageMissing = "HolderPageMissing",
}

export class AdminUserDocumentAiAutoRejectDto implements IAdminUserDocumentAiAutoRejectDto {
    reason!: UserFileAiGuidanceReason;
    rejectionReason!: UserFileRejectionReason;
    rejects!: boolean;
    blockers!: UserFileAiAutoRejectBlocker[] | undefined;
    rejectedAt!: Date | undefined;

    constructor(data?: IAdminUserDocumentAiAutoRejectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.rejectionReason = _data["rejectionReason"];
            this.rejects = _data["rejects"];
            if (Array.isArray(_data["blockers"])) {
                this.blockers = [] as any;
                for (let item of _data["blockers"])
                    this.blockers!.push(item);
            }
            this.rejectedAt = _data["rejectedAt"] ? new Date(_data["rejectedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentAiAutoRejectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiAutoRejectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["rejectionReason"] = this.rejectionReason;
        data["rejects"] = this.rejects;
        if (Array.isArray(this.blockers)) {
            data["blockers"] = [];
            for (let item of this.blockers)
                data["blockers"].push(item);
        }
        data["rejectedAt"] = this.rejectedAt ? this.rejectedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentAiAutoRejectDto {
    reason: UserFileAiGuidanceReason;
    rejectionReason: UserFileRejectionReason;
    rejects: boolean;
    blockers: UserFileAiAutoRejectBlocker[] | undefined;
    rejectedAt: Date | undefined;
}

export enum UserFileRejectionReason {
    Undefined = "Undefined",
    PoorDocumentQuality = "PoorDocumentQuality",
    ImpossibleToCheck = "ImpossibleToCheck",
    SuspicionOfForgery = "SuspicionOfForgery",
    Expired = "Expired",
    DataMismatch = "DataMismatch",
    WrongDocumentType = "WrongDocumentType",
    Other = "Other",
}

export enum UserFileAiAutoRejectBlocker {
    Undefined = "Undefined",
    NotUnrecognized = "NotUnrecognized",
    GuidanceIncomplete = "GuidanceIncomplete",
    EvidenceDisagrees = "EvidenceDisagrees",
    RiskFlagRaised = "RiskFlagRaised",
    ClassificationNotConfident = "ClassificationNotConfident",
    UploadedAsOther = "UploadedAsOther",
    FileRetyped = "FileRetyped",
    MessageQuotesPersonalData = "MessageQuotesPersonalData",
    TooManyPages = "TooManyPages",
}

export class AdminUserDocumentAiProfileCorrectionDto implements IAdminUserDocumentAiProfileCorrectionDto {
    lastName!: string | undefined;
    firstName!: string | undefined;
    middleName!: string | undefined;
    birthDate!: string | undefined;
    fields!: UserFileAiComparedField[] | undefined;
    reason!: string | undefined;

    constructor(data?: IAdminUserDocumentAiProfileCorrectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiProfileCorrectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiProfileCorrectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["reason"] = this.reason;
        return data;
    }
}

export interface IAdminUserDocumentAiProfileCorrectionDto {
    lastName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    birthDate: string | undefined;
    fields: UserFileAiComparedField[] | undefined;
    reason: string | undefined;
}

export class AdminUserDocumentAiStageTokensDto implements IAdminUserDocumentAiStageTokensDto {
    stage!: string | undefined;
    promptTokens!: number;
    completionTokens!: number;

    constructor(data?: IAdminUserDocumentAiStageTokensDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiStageTokensDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiStageTokensDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        return data;
    }
}

export interface IAdminUserDocumentAiStageTokensDto {
    stage: string | undefined;
    promptTokens: number;
    completionTokens: number;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class XProblemDetailsOfAdminUserDocumentsProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminUserDocumentsProblemCode {
    problemCode!: AdminUserDocumentsProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminUserDocumentsProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminUserDocumentsProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminUserDocumentsProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminUserDocumentsProblemCode extends IProblemDetails {
    problemCode: AdminUserDocumentsProblemCode;

    [key: string]: any;
}

export enum AdminUserDocumentsProblemCode {
    Unhandled = "Unhandled",
    NotFound = "NotFound",
    DocumentDeleted = "DocumentDeleted",
    PageContentUnavailable = "PageContentUnavailable",
    RejectionReasonRequired = "RejectionReasonRequired",
    StatusTransitionNotAllowed = "StatusTransitionNotAllowed",
    AiCheckNotFound = "AiCheckNotFound",
    UnsupportedFormat = "UnsupportedFormat",
    AiCheckDisabled = "AiCheckDisabled",
    InvalidAction = "InvalidAction",
    DocumentNotFound = "DocumentNotFound",
    DocumentTypeNotSupported = "DocumentTypeNotSupported",
    AiExtractionMissing = "AiExtractionMissing",
    DocumentAlreadyCreated = "DocumentAlreadyCreated",
    DocumentAlreadyExists = "DocumentAlreadyExists",
    AiCheckOutdated = "AiCheckOutdated",
    ProfileFieldsInvalid = "ProfileFieldsInvalid",
    ReportPeriodInvalid = "ReportPeriodInvalid",
    PageNotFound = "PageNotFound",
    DocumentChangedConcurrently = "DocumentChangedConcurrently",
    DocumentNotSubmitted = "DocumentNotSubmitted",
}

export class AdminUserDocumentDecisionRequestDto implements IAdminUserDocumentDecisionRequestDto {
    actionType!: AdminUserDocumentDecisionAction;
    rejectionReason!: UserFileRejectionReason | undefined;
    comment!: string | undefined;
    aiCheckId!: number | undefined;
    pagesVersion!: number | undefined;

    constructor(data?: IAdminUserDocumentDecisionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.rejectionReason = _data["rejectionReason"];
            this.comment = _data["comment"];
            this.aiCheckId = _data["aiCheckId"];
            this.pagesVersion = _data["pagesVersion"];
        }
    }

    static fromJS(data: any): AdminUserDocumentDecisionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDecisionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["rejectionReason"] = this.rejectionReason;
        data["comment"] = this.comment;
        data["aiCheckId"] = this.aiCheckId;
        data["pagesVersion"] = this.pagesVersion;
        return data;
    }
}

export interface IAdminUserDocumentDecisionRequestDto {
    actionType: AdminUserDocumentDecisionAction;
    rejectionReason: UserFileRejectionReason | undefined;
    comment: string | undefined;
    aiCheckId: number | undefined;
    pagesVersion: number | undefined;
}

export enum AdminUserDocumentDecisionAction {
    Undefined = "Undefined",
    Approve = "Approve",
    Reject = "Reject",
}

export class AdminUserDocumentVerifiedDocumentDto implements IAdminUserDocumentVerifiedDocumentDto {
    documentId!: number;
    documentKey!: string | undefined;
    documentName!: string | undefined;
    stateType!: DocumentStateType;
    createdAt!: Date;
    deletedAt!: Date | undefined;

    constructor(data?: IAdminUserDocumentVerifiedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentKey = _data["documentKey"];
            this.documentName = _data["documentName"];
            this.stateType = _data["stateType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentVerifiedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentVerifiedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentKey"] = this.documentKey;
        data["documentName"] = this.documentName;
        data["stateType"] = this.stateType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentVerifiedDocumentDto {
    documentId: number;
    documentKey: string | undefined;
    documentName: string | undefined;
    stateType: DocumentStateType;
    createdAt: Date;
    deletedAt: Date | undefined;
}

export enum DocumentStateType {
    Undefined = 0,
    Created = 1,
    InProcess = 2,
    ImpossibleToCheck = 3,
    AddOnsRequired = 4,
    SupervisorRequired = 5,
    Rejected = 6,
    Verified = 7,
}

export class AdminUserDocumentApproveWithDocumentRequestDto implements IAdminUserDocumentApproveWithDocumentRequestDto {
    comment!: string | undefined;
    aiCheckId!: number;
    pagesVersion!: number | undefined;

    constructor(data?: IAdminUserDocumentApproveWithDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.aiCheckId = _data["aiCheckId"];
            this.pagesVersion = _data["pagesVersion"];
        }
    }

    static fromJS(data: any): AdminUserDocumentApproveWithDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentApproveWithDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["aiCheckId"] = this.aiCheckId;
        data["pagesVersion"] = this.pagesVersion;
        return data;
    }
}

export interface IAdminUserDocumentApproveWithDocumentRequestDto {
    comment: string | undefined;
    aiCheckId: number;
    pagesVersion: number | undefined;
}

export class AdminUserDocumentHistoryEntryDto implements IAdminUserDocumentHistoryEntryDto {
    id!: number;
    actionType!: UserDocumentActionType;
    pageId!: number | undefined;
    oldStatus!: UserDocumentStatus;
    newStatus!: UserDocumentStatus;
    rejectionReason!: UserFileRejectionReason | undefined;
    inspectorId!: string | undefined;
    inspectorName!: string | undefined;
    comment!: string | undefined;
    aiCheckId!: number | undefined;
    aiVerdict!: UserFileAiVerdict | undefined;
    aiRiskFlags!: UserFileAiRiskFlags[] | undefined;
    createdAt!: Date;

    constructor(data?: IAdminUserDocumentHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionType = _data["actionType"];
            this.pageId = _data["pageId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
            this.rejectionReason = _data["rejectionReason"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.comment = _data["comment"];
            this.aiCheckId = _data["aiCheckId"];
            this.aiVerdict = _data["aiVerdict"];
            if (Array.isArray(_data["aiRiskFlags"])) {
                this.aiRiskFlags = [] as any;
                for (let item of _data["aiRiskFlags"])
                    this.aiRiskFlags!.push(item);
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionType"] = this.actionType;
        data["pageId"] = this.pageId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        data["rejectionReason"] = this.rejectionReason;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["comment"] = this.comment;
        data["aiCheckId"] = this.aiCheckId;
        data["aiVerdict"] = this.aiVerdict;
        if (Array.isArray(this.aiRiskFlags)) {
            data["aiRiskFlags"] = [];
            for (let item of this.aiRiskFlags)
                data["aiRiskFlags"].push(item);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentHistoryEntryDto {
    id: number;
    actionType: UserDocumentActionType;
    pageId: number | undefined;
    oldStatus: UserDocumentStatus;
    newStatus: UserDocumentStatus;
    rejectionReason: UserFileRejectionReason | undefined;
    inspectorId: string | undefined;
    inspectorName: string | undefined;
    comment: string | undefined;
    aiCheckId: number | undefined;
    aiVerdict: UserFileAiVerdict | undefined;
    aiRiskFlags: UserFileAiRiskFlags[] | undefined;
    createdAt: Date;
}

export enum UserDocumentActionType {
    Undefined = "Undefined",
    Approve = "Approve",
    Reject = "Reject",
    Delete = "Delete",
    AiCheckRequested = "AiCheckRequested",
    DocumentTypeChanged = "DocumentTypeChanged",
    ProfileUpdatedFromDocument = "ProfileUpdatedFromDocument",
    PageAdded = "PageAdded",
    PageDeleted = "PageDeleted",
    Submitted = "Submitted",
    AutoDocumentStoodDown = "AutoDocumentStoodDown",
}

export class AdminUserDocumentProfileUpdatedFromDocumentRequestDto implements IAdminUserDocumentProfileUpdatedFromDocumentRequestDto {
    aiCheckId!: number;
    fields!: UserFileAiComparedField[];

    constructor(data?: IAdminUserDocumentProfileUpdatedFromDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aiCheckId = _data["aiCheckId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentProfileUpdatedFromDocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentProfileUpdatedFromDocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aiCheckId"] = this.aiCheckId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        return data;
    }
}

export interface IAdminUserDocumentProfileUpdatedFromDocumentRequestDto {
    aiCheckId: number;
    fields: UserFileAiComparedField[];
}

export class AdminUserDocumentAiChecksDto implements IAdminUserDocumentAiChecksDto {
    aiCheckEnabled!: boolean;
    checks!: AdminUserDocumentAiCheckDto[] | undefined;

    constructor(data?: IAdminUserDocumentAiChecksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aiCheckEnabled = _data["aiCheckEnabled"];
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(AdminUserDocumentAiCheckDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentAiChecksDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiChecksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aiCheckEnabled"] = this.aiCheckEnabled;
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminUserDocumentAiChecksDto {
    aiCheckEnabled: boolean;
    checks: AdminUserDocumentAiCheckDto[] | undefined;
}

export class AdminUserDocumentAiCheckReportDto implements IAdminUserDocumentAiCheckReportDto {
    period!: AdminUserDocumentAiCheckReportPeriodDto | undefined;
    checks!: AdminUserDocumentAiCheckReportChecksDto | undefined;
    documents!: AdminUserDocumentDecisionReportDto | undefined;

    constructor(data?: IAdminUserDocumentAiCheckReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? AdminUserDocumentAiCheckReportPeriodDto.fromJS(_data["period"]) : undefined as any;
            this.checks = _data["checks"] ? AdminUserDocumentAiCheckReportChecksDto.fromJS(_data["checks"]) : undefined as any;
            this.documents = _data["documents"] ? AdminUserDocumentDecisionReportDto.fromJS(_data["documents"]) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : undefined as any;
        data["checks"] = this.checks ? this.checks.toJSON() : undefined as any;
        data["documents"] = this.documents ? this.documents.toJSON() : undefined as any;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportDto {
    period: AdminUserDocumentAiCheckReportPeriodDto | undefined;
    checks: AdminUserDocumentAiCheckReportChecksDto | undefined;
    documents: AdminUserDocumentDecisionReportDto | undefined;
}

export class AdminUserDocumentAiCheckReportPeriodDto implements IAdminUserDocumentAiCheckReportPeriodDto {
    from!: Date;
    to!: Date;
    timeOffsetInMinutes!: number;
    days!: number;

    constructor(data?: IAdminUserDocumentAiCheckReportPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.timeOffsetInMinutes = _data["timeOffsetInMinutes"];
            this.days = _data["days"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["timeOffsetInMinutes"] = this.timeOffsetInMinutes;
        data["days"] = this.days;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportPeriodDto {
    from: Date;
    to: Date;
    timeOffsetInMinutes: number;
    days: number;
}

export class AdminUserDocumentAiCheckReportChecksDto implements IAdminUserDocumentAiCheckReportChecksDto {
    total!: number;
    completed!: number;
    failed!: number;
    failedByReason!: AdminUserDocumentAiCheckReportFailureDto[] | undefined;
    byVerdict!: AdminUserDocumentAiCheckReportVerdictDto[] | undefined;
    wrongType!: number;
    tokens!: AdminUserDocumentAiCheckReportTokensDto | undefined;
    perDay!: AdminUserDocumentAiCheckReportDayDto[] | undefined;

    constructor(data?: IAdminUserDocumentAiCheckReportChecksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.completed = _data["completed"];
            this.failed = _data["failed"];
            if (Array.isArray(_data["failedByReason"])) {
                this.failedByReason = [] as any;
                for (let item of _data["failedByReason"])
                    this.failedByReason!.push(AdminUserDocumentAiCheckReportFailureDto.fromJS(item));
            }
            if (Array.isArray(_data["byVerdict"])) {
                this.byVerdict = [] as any;
                for (let item of _data["byVerdict"])
                    this.byVerdict!.push(AdminUserDocumentAiCheckReportVerdictDto.fromJS(item));
            }
            this.wrongType = _data["wrongType"];
            this.tokens = _data["tokens"] ? AdminUserDocumentAiCheckReportTokensDto.fromJS(_data["tokens"]) : undefined as any;
            if (Array.isArray(_data["perDay"])) {
                this.perDay = [] as any;
                for (let item of _data["perDay"])
                    this.perDay!.push(AdminUserDocumentAiCheckReportDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportChecksDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportChecksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completed"] = this.completed;
        data["failed"] = this.failed;
        if (Array.isArray(this.failedByReason)) {
            data["failedByReason"] = [];
            for (let item of this.failedByReason)
                data["failedByReason"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.byVerdict)) {
            data["byVerdict"] = [];
            for (let item of this.byVerdict)
                data["byVerdict"].push(item ? item.toJSON() : undefined as any);
        }
        data["wrongType"] = this.wrongType;
        data["tokens"] = this.tokens ? this.tokens.toJSON() : undefined as any;
        if (Array.isArray(this.perDay)) {
            data["perDay"] = [];
            for (let item of this.perDay)
                data["perDay"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportChecksDto {
    total: number;
    completed: number;
    failed: number;
    failedByReason: AdminUserDocumentAiCheckReportFailureDto[] | undefined;
    byVerdict: AdminUserDocumentAiCheckReportVerdictDto[] | undefined;
    wrongType: number;
    tokens: AdminUserDocumentAiCheckReportTokensDto | undefined;
    perDay: AdminUserDocumentAiCheckReportDayDto[] | undefined;
}

export class AdminUserDocumentAiCheckReportFailureDto implements IAdminUserDocumentAiCheckReportFailureDto {
    reason!: UserFileAiCheckFailureReason;
    count!: number;

    constructor(data?: IAdminUserDocumentAiCheckReportFailureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportFailureDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportFailureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["count"] = this.count;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportFailureDto {
    reason: UserFileAiCheckFailureReason;
    count: number;
}

export enum UserFileAiCheckFailureReason {
    Undefined = "Undefined",
    ProviderUnavailable = "ProviderUnavailable",
    ProviderRejected = "ProviderRejected",
    InvalidModelResponse = "InvalidModelResponse",
    FileServerUnavailable = "FileServerUnavailable",
    ProfileUnavailable = "ProfileUnavailable",
    ContentUnavailable = "ContentUnavailable",
    UnsupportedFormat = "UnsupportedFormat",
    TimedOut = "TimedOut",
    FileDeleted = "FileDeleted",
    InternalError = "InternalError",
    Other = "Other",
    DocumentNotSubmitted = "DocumentNotSubmitted",
}

export class AdminUserDocumentAiCheckReportVerdictDto implements IAdminUserDocumentAiCheckReportVerdictDto {
    verdict!: UserFileAiVerdict;
    count!: number;

    constructor(data?: IAdminUserDocumentAiCheckReportVerdictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verdict = _data["verdict"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportVerdictDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportVerdictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verdict"] = this.verdict;
        data["count"] = this.count;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportVerdictDto {
    verdict: UserFileAiVerdict;
    count: number;
}

export class AdminUserDocumentAiCheckReportTokensDto implements IAdminUserDocumentAiCheckReportTokensDto {
    promptTokens!: number;
    completionTokens!: number;
    totalTokens!: number;
    checksWithUsage!: number;
    averagePerCheck!: number | undefined;
    byModel!: AdminUserDocumentAiCheckReportModelTokensDto[] | undefined;
    byStage!: AdminUserDocumentAiCheckReportStageTokensDto[] | undefined;

    constructor(data?: IAdminUserDocumentAiCheckReportTokensDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.checksWithUsage = _data["checksWithUsage"];
            this.averagePerCheck = _data["averagePerCheck"];
            if (Array.isArray(_data["byModel"])) {
                this.byModel = [] as any;
                for (let item of _data["byModel"])
                    this.byModel!.push(AdminUserDocumentAiCheckReportModelTokensDto.fromJS(item));
            }
            if (Array.isArray(_data["byStage"])) {
                this.byStage = [] as any;
                for (let item of _data["byStage"])
                    this.byStage!.push(AdminUserDocumentAiCheckReportStageTokensDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportTokensDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportTokensDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["checksWithUsage"] = this.checksWithUsage;
        data["averagePerCheck"] = this.averagePerCheck;
        if (Array.isArray(this.byModel)) {
            data["byModel"] = [];
            for (let item of this.byModel)
                data["byModel"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.byStage)) {
            data["byStage"] = [];
            for (let item of this.byStage)
                data["byStage"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportTokensDto {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
    checksWithUsage: number;
    averagePerCheck: number | undefined;
    byModel: AdminUserDocumentAiCheckReportModelTokensDto[] | undefined;
    byStage: AdminUserDocumentAiCheckReportStageTokensDto[] | undefined;
}

export class AdminUserDocumentAiCheckReportModelTokensDto implements IAdminUserDocumentAiCheckReportModelTokensDto {
    model!: string | undefined;
    checks!: number;
    checksWithUsage!: number;
    promptTokens!: number;
    completionTokens!: number;
    totalTokens!: number;
    averagePerCheck!: number | undefined;

    constructor(data?: IAdminUserDocumentAiCheckReportModelTokensDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.checks = _data["checks"];
            this.checksWithUsage = _data["checksWithUsage"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.averagePerCheck = _data["averagePerCheck"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportModelTokensDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportModelTokensDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["checks"] = this.checks;
        data["checksWithUsage"] = this.checksWithUsage;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["averagePerCheck"] = this.averagePerCheck;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportModelTokensDto {
    model: string | undefined;
    checks: number;
    checksWithUsage: number;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
    averagePerCheck: number | undefined;
}

export class AdminUserDocumentAiCheckReportStageTokensDto implements IAdminUserDocumentAiCheckReportStageTokensDto {
    stage!: string | undefined;
    promptTokens!: number | undefined;
    completionTokens!: number | undefined;
    totalTokens!: number | undefined;

    constructor(data?: IAdminUserDocumentAiCheckReportStageTokensDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportStageTokensDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportStageTokensDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportStageTokensDto {
    stage: string | undefined;
    promptTokens: number | undefined;
    completionTokens: number | undefined;
    totalTokens: number | undefined;
}

export class AdminUserDocumentAiCheckReportDayDto implements IAdminUserDocumentAiCheckReportDayDto {
    reportDate!: Date;
    match!: number;
    discrepancies!: number;
    unrecognized!: number;
    failed!: number;
    promptTokens!: number;
    completionTokens!: number;

    constructor(data?: IAdminUserDocumentAiCheckReportDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined as any;
            this.match = _data["match"];
            this.discrepancies = _data["discrepancies"];
            this.unrecognized = _data["unrecognized"];
            this.failed = _data["failed"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckReportDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckReportDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDate"] = this.reportDate ? this.reportDate.toISOString() : undefined as any;
        data["match"] = this.match;
        data["discrepancies"] = this.discrepancies;
        data["unrecognized"] = this.unrecognized;
        data["failed"] = this.failed;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckReportDayDto {
    reportDate: Date;
    match: number;
    discrepancies: number;
    unrecognized: number;
    failed: number;
    promptTokens: number;
    completionTokens: number;
}

export class AdminUserDocumentDecisionReportDto implements IAdminUserDocumentDecisionReportDto {
    approved!: AdminUserDocumentDecisionCountsDto | undefined;
    rejected!: AdminUserDocumentRejectionCountsDto | undefined;
    perDay!: AdminUserDocumentDecisionDayDto[] | undefined;

    constructor(data?: IAdminUserDocumentDecisionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approved = _data["approved"] ? AdminUserDocumentDecisionCountsDto.fromJS(_data["approved"]) : undefined as any;
            this.rejected = _data["rejected"] ? AdminUserDocumentRejectionCountsDto.fromJS(_data["rejected"]) : undefined as any;
            if (Array.isArray(_data["perDay"])) {
                this.perDay = [] as any;
                for (let item of _data["perDay"])
                    this.perDay!.push(AdminUserDocumentDecisionDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentDecisionReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDecisionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved ? this.approved.toJSON() : undefined as any;
        data["rejected"] = this.rejected ? this.rejected.toJSON() : undefined as any;
        if (Array.isArray(this.perDay)) {
            data["perDay"] = [];
            for (let item of this.perDay)
                data["perDay"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminUserDocumentDecisionReportDto {
    approved: AdminUserDocumentDecisionCountsDto | undefined;
    rejected: AdminUserDocumentRejectionCountsDto | undefined;
    perDay: AdminUserDocumentDecisionDayDto[] | undefined;
}

export class AdminUserDocumentDecisionCountsDto implements IAdminUserDocumentDecisionCountsDto {
    moderator!: number;
    automatic!: number;
    total!: number;

    constructor(data?: IAdminUserDocumentDecisionCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moderator = _data["moderator"];
            this.automatic = _data["automatic"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AdminUserDocumentDecisionCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDecisionCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moderator"] = this.moderator;
        data["automatic"] = this.automatic;
        data["total"] = this.total;
        return data;
    }
}

export interface IAdminUserDocumentDecisionCountsDto {
    moderator: number;
    automatic: number;
    total: number;
}

export class AdminUserDocumentRejectionCountsDto implements IAdminUserDocumentRejectionCountsDto {
    moderator!: number;
    automatic!: number;
    total!: number;
    byReason!: AdminUserDocumentRejectionReasonCountDto[] | undefined;

    constructor(data?: IAdminUserDocumentRejectionCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moderator = _data["moderator"];
            this.automatic = _data["automatic"];
            this.total = _data["total"];
            if (Array.isArray(_data["byReason"])) {
                this.byReason = [] as any;
                for (let item of _data["byReason"])
                    this.byReason!.push(AdminUserDocumentRejectionReasonCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentRejectionCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentRejectionCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moderator"] = this.moderator;
        data["automatic"] = this.automatic;
        data["total"] = this.total;
        if (Array.isArray(this.byReason)) {
            data["byReason"] = [];
            for (let item of this.byReason)
                data["byReason"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminUserDocumentRejectionCountsDto {
    moderator: number;
    automatic: number;
    total: number;
    byReason: AdminUserDocumentRejectionReasonCountDto[] | undefined;
}

export class AdminUserDocumentRejectionReasonCountDto implements IAdminUserDocumentRejectionReasonCountDto {
    reason!: UserFileRejectionReason;
    moderator!: number;
    automatic!: number;
    total!: number;

    constructor(data?: IAdminUserDocumentRejectionReasonCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.moderator = _data["moderator"];
            this.automatic = _data["automatic"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AdminUserDocumentRejectionReasonCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentRejectionReasonCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["moderator"] = this.moderator;
        data["automatic"] = this.automatic;
        data["total"] = this.total;
        return data;
    }
}

export interface IAdminUserDocumentRejectionReasonCountDto {
    reason: UserFileRejectionReason;
    moderator: number;
    automatic: number;
    total: number;
}

export class AdminUserDocumentDecisionDayDto implements IAdminUserDocumentDecisionDayDto {
    reportDate!: Date;
    approvedByModerator!: number;
    approvedAutomatically!: number;
    rejectedByModerator!: number;
    rejectedAutomatically!: number;

    constructor(data?: IAdminUserDocumentDecisionDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined as any;
            this.approvedByModerator = _data["approvedByModerator"];
            this.approvedAutomatically = _data["approvedAutomatically"];
            this.rejectedByModerator = _data["rejectedByModerator"];
            this.rejectedAutomatically = _data["rejectedAutomatically"];
        }
    }

    static fromJS(data: any): AdminUserDocumentDecisionDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentDecisionDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDate"] = this.reportDate ? this.reportDate.toISOString() : undefined as any;
        data["approvedByModerator"] = this.approvedByModerator;
        data["approvedAutomatically"] = this.approvedAutomatically;
        data["rejectedByModerator"] = this.rejectedByModerator;
        data["rejectedAutomatically"] = this.rejectedAutomatically;
        return data;
    }
}

export interface IAdminUserDocumentDecisionDayDto {
    reportDate: Date;
    approvedByModerator: number;
    approvedAutomatically: number;
    rejectedByModerator: number;
    rejectedAutomatically: number;
}

export class AdminUserDocumentAiCheckBulkResultDto implements IAdminUserDocumentAiCheckBulkResultDto {
    matched!: number;
    queued!: number;
    skippedDeleted!: number;
    skippedNotSubmitted!: number;
    skippedUnsupported!: number;
    skippedAlreadyQueued!: number;
    skippedCheckedAfter!: number;
    truncated!: number;
    queuedDocumentIds!: number[] | undefined;

    constructor(data?: IAdminUserDocumentAiCheckBulkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matched = _data["matched"];
            this.queued = _data["queued"];
            this.skippedDeleted = _data["skippedDeleted"];
            this.skippedNotSubmitted = _data["skippedNotSubmitted"];
            this.skippedUnsupported = _data["skippedUnsupported"];
            this.skippedAlreadyQueued = _data["skippedAlreadyQueued"];
            this.skippedCheckedAfter = _data["skippedCheckedAfter"];
            this.truncated = _data["truncated"];
            if (Array.isArray(_data["queuedDocumentIds"])) {
                this.queuedDocumentIds = [] as any;
                for (let item of _data["queuedDocumentIds"])
                    this.queuedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckBulkResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckBulkResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matched"] = this.matched;
        data["queued"] = this.queued;
        data["skippedDeleted"] = this.skippedDeleted;
        data["skippedNotSubmitted"] = this.skippedNotSubmitted;
        data["skippedUnsupported"] = this.skippedUnsupported;
        data["skippedAlreadyQueued"] = this.skippedAlreadyQueued;
        data["skippedCheckedAfter"] = this.skippedCheckedAfter;
        data["truncated"] = this.truncated;
        if (Array.isArray(this.queuedDocumentIds)) {
            data["queuedDocumentIds"] = [];
            for (let item of this.queuedDocumentIds)
                data["queuedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAdminUserDocumentAiCheckBulkResultDto {
    matched: number;
    queued: number;
    skippedDeleted: number;
    skippedNotSubmitted: number;
    skippedUnsupported: number;
    skippedAlreadyQueued: number;
    skippedCheckedAfter: number;
    truncated: number;
    queuedDocumentIds: number[] | undefined;
}

export class AdminUserDocumentAiCheckBulkRequestDto implements IAdminUserDocumentAiCheckBulkRequestDto {
    since!: Date;
    until!: Date | undefined;
    statuses!: UserDocumentStatus[] | undefined;
    documentTypes!: DocumentType[] | undefined;
    skipCheckedAfter!: Date | undefined;
    applyAutoReject!: boolean;
    dryRun!: boolean;
    limit!: number;

    constructor(data?: IAdminUserDocumentAiCheckBulkRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.since = _data["since"] ? new Date(_data["since"].toString()) : undefined as any;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : undefined as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.skipCheckedAfter = _data["skipCheckedAfter"] ? new Date(_data["skipCheckedAfter"].toString()) : undefined as any;
            this.applyAutoReject = _data["applyAutoReject"];
            this.dryRun = _data["dryRun"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AdminUserDocumentAiCheckBulkRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDocumentAiCheckBulkRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["since"] = this.since ? this.since.toISOString() : undefined as any;
        data["until"] = this.until ? this.until.toISOString() : undefined as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["skipCheckedAfter"] = this.skipCheckedAfter ? this.skipCheckedAfter.toISOString() : undefined as any;
        data["applyAutoReject"] = this.applyAutoReject;
        data["dryRun"] = this.dryRun;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAdminUserDocumentAiCheckBulkRequestDto {
    since: Date;
    until: Date | undefined;
    statuses: UserDocumentStatus[] | undefined;
    documentTypes: DocumentType[] | undefined;
    skipCheckedAfter: Date | undefined;
    applyAutoReject: boolean;
    dryRun: boolean;
    limit: number;
}

export class AdminDocumentDto implements IAdminDocumentDto {
    id!: number;
    documentKey!: string | undefined;
    documentName!: string | undefined;
    userId!: string;
    customerHumanReadableId!: number | undefined;
    customerName!: string | undefined;
    customerRoleType!: AdminCustomerRole | undefined;
    stateType!: DocumentStateType;
    createdAt!: Date;
    modifiedAt!: Date | undefined;
    deletedAt!: Date | undefined;
    decisionDate!: Date | undefined;
    rusMvdPassportCheck!: boolean | undefined;

    constructor(data?: IAdminDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentKey = _data["documentKey"];
            this.documentName = _data["documentName"];
            this.userId = _data["userId"];
            this.customerHumanReadableId = _data["customerHumanReadableId"];
            this.customerName = _data["customerName"];
            this.customerRoleType = _data["customerRoleType"];
            this.stateType = _data["stateType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : undefined as any;
            this.rusMvdPassportCheck = _data["rusMvdPassportCheck"];
        }
    }

    static fromJS(data: any): AdminDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentKey"] = this.documentKey;
        data["documentName"] = this.documentName;
        data["userId"] = this.userId;
        data["customerHumanReadableId"] = this.customerHumanReadableId;
        data["customerName"] = this.customerName;
        data["customerRoleType"] = this.customerRoleType;
        data["stateType"] = this.stateType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : undefined as any;
        data["rusMvdPassportCheck"] = this.rusMvdPassportCheck;
        return data;
    }
}

export interface IAdminDocumentDto {
    id: number;
    documentKey: string | undefined;
    documentName: string | undefined;
    userId: string;
    customerHumanReadableId: number | undefined;
    customerName: string | undefined;
    customerRoleType: AdminCustomerRole | undefined;
    stateType: DocumentStateType;
    createdAt: Date;
    modifiedAt: Date | undefined;
    deletedAt: Date | undefined;
    decisionDate: Date | undefined;
    rusMvdPassportCheck: boolean | undefined;
}

export class AdminDocumentMetadataDto implements IAdminDocumentMetadataDto {
    documentKey!: string | undefined;
    documentName!: string | undefined;
    fields!: AdminDocumentFieldMetadataDto[] | undefined;

    constructor(data?: IAdminDocumentMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentKey = _data["documentKey"];
            this.documentName = _data["documentName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AdminDocumentFieldMetadataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDocumentMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentKey"] = this.documentKey;
        data["documentName"] = this.documentName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminDocumentMetadataDto {
    documentKey: string | undefined;
    documentName: string | undefined;
    fields: AdminDocumentFieldMetadataDto[] | undefined;
}

export class AdminDocumentFieldMetadataDto implements IAdminDocumentFieldMetadataDto {
    name!: string | undefined;
    displayName!: string | undefined;
    type!: FieldType;
    isRequired!: boolean;
    isEditable!: boolean;
    order!: number;

    constructor(data?: IAdminDocumentFieldMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            this.isEditable = _data["isEditable"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): AdminDocumentFieldMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentFieldMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        data["isEditable"] = this.isEditable;
        data["order"] = this.order;
        return data;
    }
}

export interface IAdminDocumentFieldMetadataDto {
    name: string | undefined;
    displayName: string | undefined;
    type: FieldType;
    isRequired: boolean;
    isEditable: boolean;
    order: number;
}

export enum FieldType {
    Text = 1,
    Integer = 2,
    Flag = 3,
    Date = 4,
}

export class AdminDocumentDetailDto implements IAdminDocumentDetailDto {
    id!: number;
    documentKey!: string | undefined;
    documentName!: string | undefined;
    userId!: string;
    stateType!: DocumentStateType;
    createdAt!: Date;
    modifiedAt!: Date | undefined;
    deletedAt!: Date | undefined;
    decisionDate!: Date | undefined;
    rusMvdPassportCheck!: boolean | undefined;
    fields!: AdminDocumentFieldValueDto[] | undefined;
    files!: AdminDocumentFileDto[] | undefined;

    constructor(data?: IAdminDocumentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentKey = _data["documentKey"];
            this.documentName = _data["documentName"];
            this.userId = _data["userId"];
            this.stateType = _data["stateType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : undefined as any;
            this.rusMvdPassportCheck = _data["rusMvdPassportCheck"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AdminDocumentFieldValueDto.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AdminDocumentFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDocumentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentKey"] = this.documentKey;
        data["documentName"] = this.documentName;
        data["userId"] = this.userId;
        data["stateType"] = this.stateType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : undefined as any;
        data["rusMvdPassportCheck"] = this.rusMvdPassportCheck;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminDocumentDetailDto {
    id: number;
    documentKey: string | undefined;
    documentName: string | undefined;
    userId: string;
    stateType: DocumentStateType;
    createdAt: Date;
    modifiedAt: Date | undefined;
    deletedAt: Date | undefined;
    decisionDate: Date | undefined;
    rusMvdPassportCheck: boolean | undefined;
    fields: AdminDocumentFieldValueDto[] | undefined;
    files: AdminDocumentFileDto[] | undefined;
}

export class AdminDocumentFieldValueDto implements IAdminDocumentFieldValueDto {
    name!: string;
    type!: FieldType;
    value!: string | undefined;

    constructor(data?: IAdminDocumentFieldValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AdminDocumentFieldValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentFieldValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IAdminDocumentFieldValueDto {
    name: string;
    type: FieldType;
    value: string | undefined;
}

export class AdminDocumentFileDto implements IAdminDocumentFileDto {
    id!: number;
    filePath!: string | undefined;

    constructor(data?: IAdminDocumentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): AdminDocumentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IAdminDocumentFileDto {
    id: number;
    filePath: string | undefined;
}

export class XProblemDetailsOfAdminDocumentsProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminDocumentsProblemCode {
    problemCode!: AdminDocumentsProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminDocumentsProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminDocumentsProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminDocumentsProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminDocumentsProblemCode extends IProblemDetails {
    problemCode: AdminDocumentsProblemCode;

    [key: string]: any;
}

export enum AdminDocumentsProblemCode {
    Unhandled = "Unhandled",
    NotFound = "NotFound",
    DocumentDeleted = "DocumentDeleted",
    MetadataNotFound = "MetadataNotFound",
    InvalidData = "InvalidData",
    EmptyFile = "EmptyFile",
    UnsupportedFileType = "UnsupportedFileType",
    FileTooLarge = "FileTooLarge",
    InvalidFilePath = "InvalidFilePath",
    CustomerNotFound = "CustomerNotFound",
    LiveAutoCreatedDocumentExists = "LiveAutoCreatedDocumentExists",
    AttachmentNotFound = "AttachmentNotFound",
    FileContentUnavailable = "FileContentUnavailable",
    FileTooLargeToPreview = "FileTooLargeToPreview",
}

export class AdminDocumentCreateRequestDto implements IAdminDocumentCreateRequestDto {
    userId!: string;
    documentKey!: string;
    fields!: AdminDocumentFieldValueDto[] | undefined;
    filePaths!: string[] | undefined;

    constructor(data?: IAdminDocumentCreateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.documentKey = _data["documentKey"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AdminDocumentFieldValueDto.fromJS(item));
            }
            if (Array.isArray(_data["filePaths"])) {
                this.filePaths = [] as any;
                for (let item of _data["filePaths"])
                    this.filePaths!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminDocumentCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentCreateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["documentKey"] = this.documentKey;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filePaths)) {
            data["filePaths"] = [];
            for (let item of this.filePaths)
                data["filePaths"].push(item);
        }
        return data;
    }
}

export interface IAdminDocumentCreateRequestDto {
    userId: string;
    documentKey: string;
    fields: AdminDocumentFieldValueDto[] | undefined;
    filePaths: string[] | undefined;
}

export class AdminDocumentEditRequestDto implements IAdminDocumentEditRequestDto {
    fields!: AdminDocumentFieldValueDto[] | undefined;
    keepFileIds!: number[] | undefined;
    filePaths!: string[] | undefined;

    constructor(data?: IAdminDocumentEditRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AdminDocumentFieldValueDto.fromJS(item));
            }
            if (Array.isArray(_data["keepFileIds"])) {
                this.keepFileIds = [] as any;
                for (let item of _data["keepFileIds"])
                    this.keepFileIds!.push(item);
            }
            if (Array.isArray(_data["filePaths"])) {
                this.filePaths = [] as any;
                for (let item of _data["filePaths"])
                    this.filePaths!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminDocumentEditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentEditRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keepFileIds)) {
            data["keepFileIds"] = [];
            for (let item of this.keepFileIds)
                data["keepFileIds"].push(item);
        }
        if (Array.isArray(this.filePaths)) {
            data["filePaths"] = [];
            for (let item of this.filePaths)
                data["filePaths"].push(item);
        }
        return data;
    }
}

export interface IAdminDocumentEditRequestDto {
    fields: AdminDocumentFieldValueDto[] | undefined;
    keepFileIds: number[] | undefined;
    filePaths: string[] | undefined;
}

export class AdminDocumentFileUploadResultDto implements IAdminDocumentFileUploadResultDto {
    filePath!: string | undefined;

    constructor(data?: IAdminDocumentFileUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): AdminDocumentFileUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentFileUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IAdminDocumentFileUploadResultDto {
    filePath: string | undefined;
}

export class AdminDocumentHistoryEntryDto implements IAdminDocumentHistoryEntryDto {
    actionType!: DocumentActionType;
    oldStateType!: DocumentStateType;
    newStateType!: DocumentStateType;
    inspectorId!: string | undefined;
    inspectorName!: string | undefined;
    comment!: string | undefined;
    createdAt!: Date;

    constructor(data?: IAdminDocumentHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.oldStateType = _data["oldStateType"];
            this.newStateType = _data["newStateType"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.comment = _data["comment"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminDocumentHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["oldStateType"] = this.oldStateType;
        data["newStateType"] = this.newStateType;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["comment"] = this.comment;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminDocumentHistoryEntryDto {
    actionType: DocumentActionType;
    oldStateType: DocumentStateType;
    newStateType: DocumentStateType;
    inspectorId: string | undefined;
    inspectorName: string | undefined;
    comment: string | undefined;
    createdAt: Date;
}

export enum DocumentActionType {
    Create = 1,
    StartProcessing = 2,
    MarkAsImpossibleToCheck = 3,
    RequireAddOns = 4,
    RequireSupervisorCheck = 5,
    Approve = 6,
    Reject = 7,
    Supersede = 8,
}

export class AdminDocumentVerificationRequestDto implements IAdminDocumentVerificationRequestDto {
    actionType!: DocumentActionType;
    comment!: string | undefined;
    rejectionReason!: RejectionReason | undefined;

    constructor(data?: IAdminDocumentVerificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.comment = _data["comment"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): AdminDocumentVerificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentVerificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["comment"] = this.comment;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IAdminDocumentVerificationRequestDto {
    actionType: DocumentActionType;
    comment: string | undefined;
    rejectionReason: RejectionReason | undefined;
}

export enum RejectionReason {
    Undefined = 0,
    PoorDocumentQuality = 1,
    ImpossibleToCheck = 2,
    SuspicionOfForgery = 3,
}

export class AdminDocumentPassportCheckResultDto implements IAdminDocumentPassportCheckResultDto {
    result!: AdminPassportCheckResult;

    constructor(data?: IAdminDocumentPassportCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): AdminDocumentPassportCheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentPassportCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IAdminDocumentPassportCheckResultDto {
    result: AdminPassportCheckResult;
}

export enum AdminPassportCheckResult {
    InvalidPassportData = 0,
    ValidPassport = 1,
    InvalidPassport = 2,
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}